import DefaultLayout from "../components/layout/DefaultLayout";
function ServicesPage() {
  const body = () => {
    return (
      <div>
        <section class="slice sct-color-1" id="scrollToSection">
          <div class="container">
            <div class="row cols-xs-space cols-md-space cols-sm-space">
              <div class="col-lg-4">
                <div class="icon-block icon-block--style-2-v1 text-center">
                  <div class="block-icon circle bg-base-1">
                    <i class="ion-ios-clock"></i>
                  </div>
                  <h2 class="heading heading-5 strong-500">
                    Administracion de Inmuebles
                  </h2>
                  <p class="px-4">
                    Entendemos lo valioso que el tiempo es para usted.
                  </p>
                  <p class="px-4">
                    Su tranquilidad es lo mas importante para nosotros.
                  </p>
                  <p class="px-4">
                    Deje que nosotros cuidemos sus propiedades,siempre estaran
                    en las mejores manos.
                  </p>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="icon-block icon-block--style-2-v1 text-center">
                  <div class="block-icon circle bg-base-1">
                    <i class="ion-ios-home"></i>
                  </div>
                  <h2 class="heading heading-5 strong-500">
                    Arriendo y Ventas
                  </h2>
                  <p class="px-4">
                    Encuentra el lugar perfecto para compartir con los tuyos y
                    vivir momentos magicos.
                  </p>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="icon-block icon-block--style-2-v1 text-center">
                  <div class="block-icon circle bg-base-1">
                    <i class="ion-ios-bookmarks"></i>
                  </div>
                  <h2 class="heading heading-5 strong-500">Certificados</h2>
                  <p class="px-4">
                    Te ayudamos gestionando el certificado de Libertad y
                    Tradicion de tu propiedad.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default ServicesPage;
